import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { SignaturePad } from "@/components/SignaturePad";

export const MEDICAL_QUESTIONS = [
  "Are you pregnant or breastfeeding?",
  "Have you taken Roaccutane (isotretinoin) in the last 6 months?",
  "Do you have active acne, eczema, psoriasis, rosacea or broken skin in the treatment area?",
  "Do you suffer from cold sores (herpes simplex)?",
  "Are you taking blood thinners or do you have a bleeding disorder?",
  "Do you have diabetes, epilepsy or an autoimmune condition?",
  "Do you have a pacemaker, metal implants or metal plates?",
  "Do you have any allergies (including to skincare products)?",
  "Have you had sunburn, a sunbed or fake tan in the last 2 weeks?",
  "Have you had injectables, laser, peels or microneedling in the last 2 weeks?",
  "Are you using retinoids, AHAs/BHAs or prescription skincare?",
];

export function ConsentForm({ value, onChange }) {
  const answers = value.answers || {};
  const setAns = (q, v) => onChange({ ...value, answers: { ...answers, [q]: v } });
  return (
    <div className="space-y-3" data-testid="consent-form">
      <div>
        <h3 className="font-semibold">Medical questionnaire</h3>
        <p className="text-xs text-stone-500">This treatment needs a health check. Your answers are private to the salon.</p>
      </div>
      {MEDICAL_QUESTIONS.map((q, i) => (
        <div key={q} className="flex items-start justify-between gap-3 text-sm">
          <span className="flex-1">{q}</span>
          <div className="flex gap-1 shrink-0">
            {["No", "Yes"].map((opt) => (
              <button key={opt} type="button" data-testid={`consent-q${i}-${opt.toLowerCase()}`} onClick={() => setAns(q, opt)}
                className={`px-3 py-1 rounded-full border text-xs ${answers[q] === opt ? "bg-stone-900 text-white border-stone-900" : "bg-white border-stone-300"}`}>{opt}</button>
            ))}
          </div>
        </div>
      ))}
      <div><Label>Anything else we should know? (medication, conditions)</Label>
        <Textarea data-testid="consent-details" value={value.details || ""} onChange={(e) => onChange({ ...value, details: e.target.value })} rows={2} className="mt-1.5 rounded-lg" /></div>
      <label className="flex items-start gap-2 text-sm">
        <Checkbox data-testid="consent-agree" checked={!!value.agreed} onCheckedChange={(v) => onChange({ ...value, agreed: !!v })} className="mt-0.5" />
        <span>I confirm my answers are true and complete, I understand the treatment, its risks and aftercare, and I consent to proceed.</span>
      </label>
      <div><Label>Signature</Label><div className="mt-1.5"><SignaturePad testid="consent-signature" onChange={(sig) => onChange({ ...value, signature: sig })} /></div></div>
    </div>
  );
}

export const consentComplete = (v) => !!(v && v.agreed && v.signature && MEDICAL_QUESTIONS.every((q) => v.answers?.[q]));

export function GuardianForm({ value, onChange }) {
  return (
    <div className="space-y-3" data-testid="guardian-form">
      <div>
        <h3 className="font-semibold">Parent / guardian consent</h3>
        <p className="text-xs text-stone-500">This treatment is for under-18s and needs a parent or guardian's consent.</p>
      </div>
      <div><Label>Parent / guardian full name</Label>
        <Input data-testid="guardian-name" value={value.name || ""} onChange={(e) => onChange({ ...value, name: e.target.value })} className="mt-1.5 h-11 rounded-lg" /></div>
      <div><Label>Parent / guardian signature</Label><div className="mt-1.5"><SignaturePad testid="guardian-signature" onChange={(sig) => onChange({ ...value, signature: sig })} /></div></div>
    </div>
  );
}
